"use client";

import { useLoadingIndicatorStore } from "@/lib/store/use-loading-indicator-store";
import { Spinner } from "../ui/spinner";
import { cn } from "@/lib/utils";
import { createPortal } from "react-dom";

interface LoadingIndicatorProps {
  className?: string;
}

export function LoadingIndicator({ className }: LoadingIndicatorProps) {
  const { loading } = useLoadingIndicatorStore();

  if (!loading) {
    return null;
  }

  return createPortal(
    <div className="fixed bg-background/50 inset-0 flex items-center justify-center z-50">
      <Spinner className={cn("size-4 animate-spin", className)} />
    </div>,
    document.body
  );
}
